import { call, put, select, takeLatest, fork } from 'redux-saga/effects';

import { updateApplicationSuccess, mapServerToUi } from '../actions';
import ApplicationAPI from '../api/ApplicationAPI';
import { PERSIST_UNSUPPORTED_SCHOOLS_INTEREST } from '../constants/actionTypes';
import { buildServerSelector, accessTokenSelector } from '../reducers/selectors';

import { manageAPIError } from './helpers/errorHelper';

function* unsupportedSchoolsInterestUpdateWatcher() {
  yield takeLatest(PERSIST_UNSUPPORTED_SCHOOLS_INTEREST, unsupportedSchoolsInterestUpdateWorker);
}

function* unsupportedSchoolsInterestUpdateWorker(action) {
  try {
    const accessToken = yield select(accessTokenSelector);
    const builder = yield select(buildServerSelector);
    const { id } = builder;
    let payload;

    if (id) {
      payload = yield call(ApplicationAPI.updateUnsupportedSchoolsInterest, builder, accessToken);

      yield put(updateApplicationSuccess({ response: payload }));
      yield put(mapServerToUi());
    }
  } catch (error) {
    yield fork(manageAPIError, { ...error, action });
  }
}

export { unsupportedSchoolsInterestUpdateWorker };
export default unsupportedSchoolsInterestUpdateWatcher;
